// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__3z31h","load2":"Spinner_load2__21iQu"};